import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useGetRole} from '@/features/users/queries/useGetRole'
import {Role} from '@/features/users/types'
import {useTranslation} from 'react-i18next'
import {Text} from '@/components/ui/text/Text'

export const AccountModalProfileRole = ({roleId}: {roleId: Role['id']}) => {
    const {t} = useTranslation()
    const roleQuery = useGetRole(roleId)

    return roleQuery.isLoading ? (
        <Skeleton height={20} width={100} />
    ) : roleQuery.isError ? (
        <InputHelpText error={t('errors:default')} />
    ) : roleQuery.data?.name ? (
        <Text size="textSm" palette="neutral" shade="600">
            {roleQuery.data.name}
        </Text>
    ) : (
        <Text size="textSm" palette="neutral" shade="600">
            {t('commons:role_not_found')}
        </Text>
    )
}
